/**
 * @fileoverview Resource data source and type definitions.
 */

import { ResourceSchema, type Resource } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createAccountTrackingFields, createArchivedAtField, createCreatedAtField, createDeletedAtField, createLookupEntityFields, createUpdatedAtField } from './field-factories';
import { getCache } from './cache-registry';

export type { Resource };

export const resourceDataSource = createBaseDataSource<Resource>({
  endpoint: 'resource',
  searchField: 'name',
  schema: ResourceSchema,
  fields: [
    ...createLookupEntityFields(),
    ...createAccountTrackingFields({ includeArchived: true }),
    createArchivedAtField(),
    createCreatedAtField(),
    createUpdatedAtField(),
    createDeletedAtField(),
  ],
});

export const resourceCache = getCache('resource');
